import { render, staticRenderFns } from "./AmountsDropdown.vue?vue&type=template&id=e25c8daa"
import script from "./AmountsDropdown.vue?vue&type=script&lang=js"
export * from "./AmountsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports